function isSalesPageWidgetCartPropertiesEnabled() {
  const params = new URLSearchParams(window.location.search || '');
  const config = window._salesPageWidgetConfig;
  return String(params.get('sw') || '').trim().toLowerCase() === 'true' &&
    config &&
    typeof config === 'object' &&
    config.enabled === true;
}

function getSalesPageWidgetCartPetName() {
  return String(window._offer?.pet_name || '').trim();
}

function getSalesPageWidgetCartForms() {
  return Array.from(document.querySelectorAll('form')).filter((form) => {
    return form?.action && form.action.includes('/cart/add');
  });
}

function getOrCreateCartPropertyInput(form, name) {
  let input = form.querySelector(`input[name="${name}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.appendChild(input);
  }

  return input;
}

function setSalesPageWidgetCartAttribution(form, attributionData, petName) {
  const input = getOrCreateCartPropertyInput(form, 'properties[_attribution]');
  let existingAttribution = {};

  try {
    existingAttribution = JSON.parse(input.value || '{}');
  } catch (error) {
    existingAttribution = {};
  }

  input.value = JSON.stringify({
    ...existingAttribution,
    ...(attributionData && typeof attributionData === 'object' ? attributionData : {}),
    ...(petName ? { pet_name: petName } : {}),
  });
}

function setSalesPageWidgetCartPetNameProperty(form, petName) {
  const input = form.querySelector('input[name="properties[Pet name]"]');
  if (!petName) {
    input?.remove();
    return;
  }

  const nextInput = input || getOrCreateCartPropertyInput(form, 'properties[Pet name]');
  nextInput.value = petName;
}

function syncSalesPageWidgetCartProperties(attributionData = {}) {
  if (!isSalesPageWidgetCartPropertiesEnabled()) {
    getSalesPageWidgetCartForms().forEach((form) => {
      setSalesPageWidgetCartPetNameProperty(form, '');
    });
    return;
  }

  const petName = getSalesPageWidgetCartPetName();

  getSalesPageWidgetCartForms().forEach((form) => {
    setSalesPageWidgetCartAttribution(form, attributionData, petName);
    setSalesPageWidgetCartPetNameProperty(form, petName);
  });
}

window.syncSalesPageWidgetCartProperties = syncSalesPageWidgetCartProperties;
